import React from 'react'
import { camelCaseToDashDelimited } from './string'
export const cloneChildrenWithProps = (children, props) =>
  React.Children.map(children, child => {
    return child ? React.cloneElement(child, props) : false
  })

export function withParentAttributesAsProps(Component) {
  return class WithParentAttributesAsProps extends Component {
    componentWillMount() {}

    render() {
      const { props, dataset } = this
      return (
        <Component
          {...{
            ...props,
            ...dataset,
          }}
        />
      )
    }
  }
}

export function reactDataset(data) {
  return Object.keys(data).reduce((acc, dataAttr) => {
    return {
      ...acc,
      [`data-${camelCaseToDashDelimited(dataAttr)}`]: data[dataAttr],
    }
  }, {})
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/reactUtils.js